module.exports = __webpack_public_path__ + "yz/img/圆通.841255d3.jpg";